exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\r\n    margin-right: -15px;\r\n    margin-left: -15px;\r\n    margin-top: 0px;\r\n}\r\n\r\nh3{\r\n    font-size: 11px;\r\n    margin-left: 10px;\r\n}\r\n\r\nh4{\r\n    font-size: 12px;\r\n    color:#656565;\r\n}\r\n\r\nh5{\r\n    font-size: 13px;\r\n    margin-left: 10px;\r\n}\r\n\r\nh6{\r\n    font-size: 12px;\r\n}\r\n\r\n.fa-remove:before, .fa-close:before, .fa-times:before {\r\n    content: \"\\F00D\";\r\n    margin: 0px 0px 0px -7px;\r\n    font-size: 18px;\r\n}\r\n\r\n.ui-panel.ui-widget {\r\n    padding: 0;\r\n    margin: 5px 0px 5px 0px !important;\r\n}\r\n.textheight{\r\n    line-height: 0em;\r\n}\r\ntbody p{\r\n    line-height: 0em;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge-summary-new/discharge-summary-new.css
// module id = ../../../../../src/app/ipd/discharge-summary-new/discharge-summary-new.css
// module chunks = main